<template>
  <div
    class="d-flex-column justify-start align-start gap-20"
    style="margin-top: 12px"
  >
    <h4 class="t-white font-family-1 title-h5 f-w-600">
      {{ $t("new_text.select_camo") }}
    </h4>

    <div class="justify-start exptra_options picker_option_container queue">
      <div
        class="picker_option d-flex-column gap-16"
        :class="[checkoutStore.getCamoCategory === packOption.id && 'selected']"
        v-for="packOption in packOptions"
        :key="packOption"
        @click.stop="() => selectOption(packOption)"
      >
        <p class="t-white medium-l font-family-2">
          {{ packOption.title }}
        </p>
      </div>
      <div
        class="picker_option d-flex-row gap-5"
        :class="[
          checkoutStore.getCamoSpecials?.id === packOption?.id && 'selected',
        ]"
        v-for="packOption in specialOptions"
        :key="packOption"
        @click.stop="selectSpecial(packOption)"
      >
        <p class="t-white medium-l font-family-2">
          {{ $t(packOption.title) }}
        </p>
        <!-- <p class="t-blue medium-l font-family-2">
          {{ userStore.getUserCurrencyCode }}{{ price(packOption) }}
        </p> -->
      </div>
    </div>
    <div class="warning_message d-flex-row justify-start" v-if="warningType">
      <img
        src="/images/icons/warning-icon-2.webp"
        alt="warning_icon"
        height="48"
        width="48"
      />
      <div class="d-flex-column justify-start align-start gap-1">
        <p class="t-white font-family-2 bold-xxl">
          {{ $t(`new_text.${warningType}_bundle`) }}
        </p>
        <p class="t-grey font-family-2 medium-m">
          {{ $t(`new_text.${warningType}_warning`) }}
        </p>
      </div>
    </div>

    <div
      class="warning_message d-flex-row justify-start"
      v-if="checkoutStore?.getCamoSpecials?.id"
    >
      <img
        src="/images/icons/warning-icon-2.webp"
        alt="warning_icon"
        height="48"
        width="48"
      />
      <div class="d-flex-column justify-start align-start gap-3">
        <p class="t-white font-family-2 bold-xxl">
          {{ $t(`${checkoutStore?.getCamoSpecials?.const_title}`) }}
        </p>
        <p class="t-grey font-family-2 medium-m">
          {{ $t(`${checkoutStore?.getCamoSpecials?.const_title}_warning`) }}
        </p>
      </div>
    </div>

    <!-- <div
      class="warning_message d-flex-row justify-start"
      v-if="
        checkoutStore?.getCamoSpecials?.id &&
        !checkoutStore?.getCamoSpecials?.const_title.includes('gold')
      "
    >
      <img
        src="/images/icons/warning-icon.webp"
        alt="warning_icon"
        height="30"
        width="30"
      />
      <p class="t-white font-family-2 medium-m">
        {{
          $t(
            `${checkoutStore?.getCamoSpecials?.const_title?.replace(
              "_bundle",
              ""
            )}_warning`
          )
        }}
      </p>
    </div> -->
  </div>
</template>

<script setup>
import { calculateCurrency } from "~/calculate/calculatePrice";
const gameStore = useGameStore();
const checkoutStore = useCheckoutStore();
const userStore = useUserStore();
const { t } = useI18n();
const packOptions = computed(() => {
  return (
    gameStore.getGamePack.pack_options?.filter(
      (gp) => !gp.const_title.includes("bundle")
    ) || []
  );
});

const specialOptions = computed(() => {
  const packPrices =
    gameStore.getGamePack?.prices?.filter((p) => p.description === "bundle") ||
    [];
  return packPrices;
});

const selectOption = (option) => {
  checkoutStore.setCamoCategory(option.id);
};

const warningType = computed(() => {
  const option = packOptions.value?.find(
    (op) => op.id === checkoutStore.getCamoCategory
  );
  if (!option) return "";
  if (["gold", "mythic_gold", "gold_tiger"].includes(option?.const_title))
    return "";
  return option?.const_title;
});

const price = (option) => {
  const pp = calculateCurrency(option.price);
  return parseFloat(pp).toFixed(2);
};

const selectSpecial = (option) => {
  const isSelected = checkoutStore.getCamoSpecials?.id === option?.id;

  if (isSelected) {
    // checkoutStore.setCamoSpecials(null);
  } else {
    checkoutStore.setCamoSpecials({
      id: option?.id,
      title: t(option?.title),
      price: price(option),
      timing: option?.timing,
      const_title: option.title,
    });
  }
};
</script>
